import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { Checkbox, Col, DatePicker, Form, Input, Radio, Row } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import snakecaseKeys from "snakecase-keys";
import { getUserDetail } from "stores/slices/user";
import {
  doGetWorkspacePage,
  getWorkspaceInfo,
  WorkspaceInfo,
} from "stores/slices/workspace";

import AppButton from "components/button";
import SelectMultiple from "components/inputs/selectSearchSingle";

import EditorQuill from "../../../components/inputs/editorQuill";
import { USER_TYPE } from "../../../constants/appConstant";
import { AuthInfo } from "../../../stores/slices/auth";
import { doCreateNotice, doUpdateNotice } from "../../../stores/slices/notice";

import styles from "../../../components/styles.module.scss";

const { RangePicker } = DatePicker;

const NoticeForm = props => {
  const {
    isViewFrm,
    noticeSelected,
    onCancel,
    onSuccess,
    onUpdate,
    setLoadingList,
    loadingList,
  } = props;
  const formRef = React.useRef(null);
  const authInfo = useSelector(AuthInfo);
  const userInfo = useSelector(getUserDetail);
  const workspaceInfo = useSelector(WorkspaceInfo);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isView, setIsView] = useState(true);

  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [workspacecQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
    sortFieldWorkspace: "createdTime",
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);
  const [isFirst, setIsFirst] = useState(true);

  const dispatch = useDispatch();

  const { workspaceId } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (authInfo.type === USER_TYPE.SUPER_ADMIN && !workspaceId) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  }, []);

  useEffect(() => {
    if (workspaceId && location.state && location.state.name) {
      setOptionWorkspace([
        {
          key: workspaceId,
          label: location.state.name,
        },
      ]);
      getWorkspaceDetail(workspaceId);
    }
  }, [workspaceId, location]);

  const getWorkspaceDetail = async () => {
    await dispatch(getWorkspaceInfo(workspaceId));
  };

  const onFinish = async fieldsValue => {
    const rangeTimeValue = fieldsValue["rangeDate"];
    const params = {
      workspaceId: workspaceId ? workspaceId : authInfo.workspaceId,
      notice: fieldsValue["notice"],
      startTime: rangeTimeValue[0].format("MM/DD/YYYY HH:mm:00"),
      endTime: rangeTimeValue[1].format("MM/DD/YYYY HH:mm:00"),
      timezoneType: fieldsValue["timezoneType"],
      workspaceAdmin:
        fieldsValue["displayFor"] &&
        fieldsValue["displayFor"].indexOf("ADMIN") !== -1,
      workspaceOperator:
        fieldsValue["displayFor"] &&
        fieldsValue["displayFor"].indexOf("OPERATOR") !== -1,
      notifyUser: fieldsValue["notify"] ? fieldsValue["notify"] : false,
    };
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      if (workspaceId) {
        params.workspaceId = workspaceId;
      } else {
        params.workspaceId = fieldsValue["workspace"];
      }
    }
    setLoading(true);

    if (noticeSelected) {
      params.id = noticeSelected.id;
      const { payload } = await dispatch(doUpdateNotice(snakecaseKeys(params)));
      if (payload && payload.status === 200) {
        setLoading(false);
        onSuccess();
      } else {
        setLoading(false);
      }
    } else {
      const { payload } = await dispatch(doCreateNotice(snakecaseKeys(params)));
      if (payload && payload.status === 200) {
        setLoading(false);
        onSuccess();
      } else {
        setLoading(false);
      }
    }
  };

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    if (request.isReset) {
      setOptionWorkspace([]);
      setListAllWorkspace([]);
      delete newRequest.isReset;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllWorkspace(removeDuplicates([...payload.content]));
      } else {
        setListAllWorkspace(
          removeDuplicates([...listAllWorkspace, ...payload.content])
        );
      }
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          key: item.id,
          label: item.name,
        };
      });
      setOptionWorkspace(newOptions);
    } else {
      if (!workspaceId) {
        setOptionWorkspace([]);
      }
    }
  }, [listAllWorkspace]);

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspacecQueries.pageNumber <= totalWorkspacePages &&
      !loadingList
    ) {
      fetchListWorkspace({
        ...workspacecQueries,
        pageNumber: workspacecQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const handleSearchKeyWorkspace = key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const validateMessages = {
    required: t("validate.required"),
  };
  const rangeConfig = {
    rules: [
      {
        type: "array",
        required: true,
        message: t("validate.required"),
      },
    ],
  };
  const initValue = noticeSelected => {
    if (noticeSelected) {
      const displayFor = [];
      noticeSelected.workspaceAdmin && displayFor.push("ADMIN");
      noticeSelected.workspaceOperator && displayFor.push("OPERATOR");
      return {
        workspace: noticeSelected.workspace?.name,
        notice: noticeSelected.notice,
        notify: noticeSelected.notifyUser,
        displayFor: displayFor,
        rangeDate: [
          dayjs(
            moment(noticeSelected.startTime).utc().format("MM/DD/YYYY HH:mm:ss")
          ),
          dayjs(
            moment(noticeSelected.endTime).utc().format("MM/DD/YYYY HH:mm:ss")
          ),
        ],
        timezoneType: noticeSelected.timezoneType,
      };
    } else if (workspaceId && location.state && location.state.name) {
      return {
        workspace: location.state.name,
        workspaceId: workspaceId,
        timezoneType: "MY_TIMEZONE",
        rangeDate: [null, null],
      };
    } else {
      return {
        timezoneType: "MY_TIMEZONE",
        rangeDate: [null, null],
      };
    }
  };

  useEffect(() => {
    setIsView(isViewFrm);
  }, [isViewFrm]);

  // const handleFormatDateTimeLocale = () => {
  //   const browserLocale = navigator.language;
  //   let dateLocale;
  //   dateLocale = moment()
  //     .tz(userInfo?.timeZone ? userInfo?.timeZone : moment.tz.guess())
  //     .locale(browserLocale);
  //   console.log("dateLocale.localeData()", dateLocale.localeData());
  //   return `${dateLocale.localeData().longDateFormat("L")} ${dateLocale
  //     .localeData()
  //     .longDateFormat("LT")
  //     .replace("A", "")
  //     .replace("h", "HH")}`;
  // };

  const handleChangeRange = dates => {
    if (isFirst) {
      setIsFirst(false);
    } else {
      formRef.current.setFieldsValue({
        rangeDate: dates,
      });
    }
  };

  return (
    <div style={{ height: "100%" }}>
      <Form
        ref={formRef}
        initialValues={initValue(noticeSelected)}
        layout={"vertical"}
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={validateMessages}
      >
        {authInfo.type === USER_TYPE.SUPER_ADMIN && (
          <>
            <p className={styles.required} style={noticeFrmStyle.labelTitle}>
              {t("user.workspace")}
            </p>
            {!noticeSelected ? (
              <Form.Item name="workspace" rules={[{ required: true }]}>
                <SelectMultiple
                  type={"select-search"}
                  disabled={isView || (workspaceId && location)}
                  loading={loadingList}
                  showSearch
                  allowClear={false}
                  optionFilterProp="children"
                  options={workspaceOption}
                  onChange={value => {
                    formRef.current.setFieldsValue({
                      workspaceId: value,
                    });
                  }}
                  config={{
                    width: "100%",
                  }}
                  handleSearch={handleSearchKeyWorkspace}
                  handleScroll={handleScrollWorkspace}
                />
              </Form.Item>
            ) : (
              <Form.Item name="workspace">
                <Input disabled placeholder={t("user.workspaceName")} />
              </Form.Item>
            )}
          </>
        )}

        <p className={styles.required} style={noticeFrmStyle.labelTitle}>
          {t("noticeBoard.noticeMsg")}
        </p>
        <Form.Item
          name="notice"
          rules={[
            {
              required: true,
              transform(value) {
                if (value === "<p><br></p>") {
                  return "";
                }
                return value;
              },
            },
          ]}
        >
          <EditorQuill
            placeholder={t("noticeBoard.textMessage")}
            readOnly={isView}
            onChange={value => {
              formRef.current.setFieldsValue({
                notice: value,
              });
            }}
          />
        </Form.Item>

        <p style={noticeFrmStyle.labelTitle}>
          {t("noticeBoard.displayMessageFor")}
        </p>
        <Form.Item name="displayFor">
          <Checkbox.Group disabled={isView}>
            <Row>
              <Col span={24} style={{ marginBottom: 4 }}>
                <Checkbox value="ADMIN" style={noticeFrmStyle.lineHeightLg}>
                  {t("noticeBoard.workspaceAdmins")}
                </Checkbox>
              </Col>
              <Col span={24}>
                <Checkbox value="OPERATOR" style={noticeFrmStyle.lineHeightLg}>
                  {t("noticeBoard.workspaceOperators")}
                </Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
        </Form.Item>

        <p className={styles.required} style={noticeFrmStyle.labelTitle}>
          {t("noticeBoard.messageWillAppearFrom")}
        </p>
        <div style={noticeFrmStyle.appearBox}>
          <div>
            <div style={{ marginBottom: 4 }}>{t("noticeBoard.rangeDate")}</div>
            <Form.Item
              style={{ marginBottom: 0 }}
              name="rangeDate"
              {...rangeConfig}
              rules={[{ type: "array", required: true }]}
            >
              <RangePicker
                style={{ width: "100%" }}
                disabled={isView}
                showTime
                format={"YYYY-MM-DD HH:mm"}
                minuteStep={5}
                // values={formRef?.current?.getFieldValue("rangeDate")}
                defaultValue={[null, null]}
                defaultPickerValue={[null, null]}
                // needConfirm={false}
                // onFocus={(event, range) => {
                //   handleFocusRange(event, range);
                // }}
                onPickerValueChange={dates => handleChangeRange(dates)}
                // onCalendarChange={dates =>}
                // changeOnScroll={true}
                popupClassName={styles.datePickerPopUp}
              />
            </Form.Item>
          </div>
          <Form.Item name="timezoneType" style={{ marginBottom: 0 }}>
            <Radio.Group disabled={isView}>
              <Row>
                <Col span={24} style={{ marginBottom: 4 }}>
                  <Radio
                    value="MY_TIMEZONE"
                    style={noticeFrmStyle.lineHeightLg}
                  >
                    {t("noticeBoard.yourTimezone", {
                      timezone: workspaceId
                        ? workspaceInfo?.workspaceSetting?.timeZone
                        : userInfo.timeZone,
                    })}
                  </Radio>
                </Col>
                <Col span={24}>
                  <Radio
                    value="USER_TIMEZONE"
                    style={noticeFrmStyle.lineHeightLg}
                  >
                    {t("noticeBoard.userTimezone")}
                  </Radio>
                </Col>
              </Row>
            </Radio.Group>
          </Form.Item>
        </div>

        <Form.Item valuePropName="checked" name="notify">
          <Checkbox style={noticeFrmStyle.checkbox} disabled={isView}>
            {t("noticeBoard.notifyUsers")}
          </Checkbox>
        </Form.Item>

        <div
          style={{
            marginTop: "16px",
            display: "flex",
            justifyContent: "end",
            gap: "16px",
          }}
        >
          <AppButton
            label={t("button.cancel")}
            color={"grey"}
            loading={loading}
            htmlType="button"
            onClick={() => {
              onCancel();
            }}
          />
          {isView && (
            <AppButton
              label={t("button.edit")}
              color={"blue"}
              loading={loading}
              type="primary"
              htmlType="button"
              onClick={() => {
                onUpdate();
              }}
            />
          )}
          {!isView && (
            <AppButton
              label={noticeSelected ? t("button.save") : t("button.create")}
              color={"blue"}
              loading={loading}
              type="primary"
              htmlType="submit"
            />
          )}
        </div>
      </Form>
    </div>
  );
};

const noticeFrmStyle = {
  labelTitle: {
    fontWeight: "bold",
    marginBottom: "6px",
  },
  lineHeightLg: {
    lineHeight: "1.2rem",
  },
  appearBox: {
    backgroundColor: "#F9FAFB",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "16px",
  },
};

export default NoticeForm;
